import { createContext, useContext } from 'react';

import { PieChartData } from '../types/pie-chart.config.js';

// eslint-disable-next-line @typescript-eslint/no-deprecated
export type PieRawDataContext = PieChartData;

export const PieChartRawDataContext = createContext<PieRawDataContext>({
  slices: [],
});

export const usePieChartRawData = () => useContext(PieChartRawDataContext);
